<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header">{{exportModal.title}}</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-text-simple
        [field]="exportModal.filenameInput"
        (itemSelected)="setFilename($event)">
      </field-type-text-simple>
      <div class="basic-data-modal__switches-container">
        <field-type-switch [field]="{label: 'export-modal.open-file'| afTranslate}"
          [small]="true"
          [preSelectItem]="exportModal.openFile"
          (itemSelected)="exportModal.openFile = $event.newValue">
        </field-type-switch>
        <field-type-switch [field]="{label: 'export-modal.download-file'| afTranslate}"
          [small]="true"
          [preSelectItem]="exportModal.downloadFile"
          (itemSelected)="exportModal.downloadFile = $event.newValue">
        </field-type-switch>
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button [ngClass]="configuration.hasPrevious?'common-button__text-noborder':'common-button__text-border'"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    @if (configuration.hasPrevious) {
      <button class="common-button__text-border"
        (click)="handleDismiss('previous')">
        <span class="common-button__text-title"
          [afTranslate]="'common.previous'">_Anterior</span>
      </button>
    }
    <button class="common-button__text"
      (click)="exportAction()">
      <span class="common-button__text-title"
        [afTranslate]="'common.export'">_Exportar</span>
    </button>
  </div>
</div>
